module.exports = __webpack_public_path__ + "ru_ico.png?f3d4f1b593157616e814ef8803a8043b";